import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.accounting.upload');
import { OnInit, ElementRef, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-accounting-upload',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.accounting.upload/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAccountingUploadComponent implements OnInit {
    @ViewChild('fileInput') fileInput: ElementRef;
    constructor(@Inject( Service) public service: Service) { }

    public uploads: any[] = [];
    public isDragging: boolean = false;
    public isUploading: boolean = false;
    public uploadProgress: string = '';

    // 선택된 업로드의 거래 내역
    public selectedUpload: any = null;
    public transactions: any[] = [];
    public isLoadingTx: boolean = false;

    public statusMap: any = {
        pending: { label: '대기', color: 'bg-zinc-100 text-zinc-600' },
        parsing: { label: '파싱중', color: 'bg-yellow-100 text-yellow-700' },
        parsed: { label: '파싱완료', color: 'bg-blue-100 text-blue-700' },
        analyzing: { label: '분석중', color: 'bg-purple-100 text-purple-700' },
        review: { label: '완료', color: 'bg-green-100 text-green-700' },
        approved: { label: '승인', color: 'bg-green-100 text-green-700' },
        rejected: { label: '반려', color: 'bg-red-100 text-red-700' },
        error: { label: '오류', color: 'bg-red-100 text-red-700' },
    };

    public directionMap: any = {
        in: { label: '입금', color: 'text-blue-600' },
        out: { label: '출금', color: 'text-red-600' },
    };

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        let res = await wiz.call("list");
        if (res.code === 200) this.uploads = res.data || [];
        await this.service.render();
    }

    public onDragOver(event: DragEvent) {
        event.preventDefault();
        this.isDragging = true;
    }

    public onDragLeave(event: DragEvent) {
        this.isDragging = false;
    }

    public async onDrop(event: DragEvent) {
        event.preventDefault();
        this.isDragging = false;
        const files = event.dataTransfer?.files;
        if (files && files.length > 0) {
            await this.uploadFile(files[0]);
        }
        await this.service.render();
    }

    public async onFileSelect(event: any) {
        const files = event.target.files;
        if (files && files.length > 0) {
            await this.uploadFile(files[0]);
        }
        await this.service.render();
    }

    public async uploadFile(file: File) {
        const ext = file.name.split('.').pop()?.toLowerCase();
        if (ext !== 'xlsx' && ext !== 'xls') {
            await this.service.modal.show({ title: '오류', message: 'xlsx 또는 xls 파일만 업로드 가능합니다.' });
            return;
        }
        if (file.size > 10 * 1024 * 1024) {
            await this.service.modal.show({ title: '오류', message: '파일 크기가 10MB를 초과합니다.' });
            return;
        }

        this.isUploading = true;
        this.uploadProgress = '업로드 및 분석 중...';
        await this.service.render();

        // wiz.call()은 FormData를 지원하지 않으므로 fetch() 직접 사용
        let result: any = null;
        try {
            const fd = new FormData();
            fd.append('file', file);
            const response = await fetch('/wiz/api/page.accounting.upload/upload', {
                method: 'POST',
                body: fd,
            });
            result = await response.json();
        } catch (e: any) {
            this.isUploading = false;
            this.uploadProgress = '';
            await this.service.modal.show({ title: '업로드 실패', message: e.message || '네트워크 오류' });
            await this.service.render();
            return;
        }

        this.isUploading = false;
        this.uploadProgress = '';
        if (this.fileInput) this.fileInput.nativeElement.value = '';

        if (result?.code === 200) {
            await this.service.modal.show({
                title: '완료',
                message: `${result.data?.rows || 0}건의 거래 내역이 파싱되었습니다.`
            });
            await this.load();
            if (result.data?.id) {
                await this.viewTransactions({ id: result.data.id, filename: file.name });
            }
        } else if (result?.code === 409) {
            await this.service.modal.show({
                title: '중복 파일',
                message: `이미 업로드된 파일입니다.`
            });
            await this.load();
        } else {
            await this.service.modal.show({
                title: '업로드 실패',
                message: result?.data?.message || result?.message || '오류가 발생했습니다.'
            });
        }
        await this.service.render();
    }

    public async viewTransactions(upload: any) {
        this.selectedUpload = upload;
        this.isLoadingTx = true;
        this.transactions = [];
        await this.service.render();

        let res = await wiz.call("transactions", { upload_id: upload.id });
        if (res.code === 200) {
            this.transactions = res.data || [];
        }
        this.isLoadingTx = false;
        await this.service.render();
    }

    public closeTransactions() {
        this.selectedUpload = null;
        this.transactions = [];
        this.service.render();
    }

    public async deleteUpload(upload: any) {
        let confirmed = await this.service.modal.show({
            title: '삭제 확인',
            message: `"${upload.filename}" 업로드와 관련 거래 내역을 모두 삭제하시겠습니까?`,
            action: '삭제'
        });
        if (!confirmed) return;

        let res = await wiz.call("delete", { upload_id: upload.id });
        if (res.code === 200) {
            if (this.selectedUpload?.id === upload.id) {
                this.closeTransactions();
            }
            await this.load();
        }
        await this.service.render();
    }

    public getStatus(status: string) {
        return this.statusMap[status] || { label: status, color: 'bg-zinc-100 text-zinc-600' };
    }

    public getDirection(dir: string) {
        return this.directionMap[dir] || { label: dir, color: 'text-zinc-600' };
    }

    public formatAmount(amount: any) {
        if (!amount) return '0';
        return Number(amount).toLocaleString();
    }

    public getTotalIn() {
        return this.transactions
            .filter((t: any) => t.direction === 'in')
            .reduce((sum: number, t: any) => sum + Number(t.amount || 0), 0);
    }

    public getTotalOut() {
        return this.transactions
            .filter((t: any) => t.direction === 'out')
            .reduce((sum: number, t: any) => sum + Number(t.amount || 0), 0);
    }
}

export default PageAccountingUploadComponent;